import {
  CmpSelectBox,
  CmpDatePicker,
  CmpTextFieldEnter,
  CmpButton,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import { DispatchData_Set, DispatchHead_Set } from "./SliceDispatch";
import moment from "moment";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import Dispatch_Breadcrumbs from "./Dispatch_BreadCrumbs";
import useMediaQuery from "@mui/material/useMediaQuery";
import DispatchModal from "./component/DispatchModal";
import { DispatchSummaryTblCard } from "./component/DispatchSummaryTblCard";
const statusData = [
  {
    id: "Pending",
    statusName: "Pending",
  },
  {
    id: "Completed",
    statusName: "Completed",
  },
  {
    id: "All",
    statusName: "All",
  },
  {
    id: "Progress",
    statusName: "Progress",
  },
];
const Gridcolumns = [
  {
    field: "VocNo",
    headerName: "Voc No",
    width: 150,
  },
  {
    field: "PostDate",
    headerName: "Post Date",
    width: 150,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "PartyName",
    headerName: "Party Name",
    width: 300,
  },
  {
    field: "Status",
    headerName: "Status",
    width: 150,
  },
];

export default function DispatchHead() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const LocationDispatchOnLoad = useRef(null);
  const sEnterKeyObj = {
    key: "Enter",
  };
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const vRdxSliceData = useSelector(
    (state) => state.SliceDispatch.value.DispatchData
  );

  const [sLocation, SetLocation] = useState(vRdxuserLoc);
  const [sLoadObj, setLoadObj] = useState(vRdxSliceData);
  const [sGridrows, setGridrows] = useState([]);

  const fOnChangeSelect = (e) => {
    setLoadObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fOnChangeInput = (e) => {
    setLoadObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fOnKeyUp = async (e) => {
    if (e.key === "Enter") {
      if (sLoadObj?.Scan != "") {
        let summaryResp = await GetSummaryList();
        if (summaryResp?.length > 0) {
          let resultObj = summaryResp[0];
          dispatch(
            DispatchHead_Set({
              VocTyp: resultObj.VocTyp,
              VocTypName: resultObj.VocTypName,
              VocNo: resultObj.VocNo,
              PostDate: moment(resultObj.PostDate, "DD/MM/YYYY")._d,
              Party: resultObj.Party,
              PartyName: resultObj.PartyName,
              Loc: resultObj.Loc,
              LocName: resultObj.LocName,
              DocStatus: resultObj.DocStatus,
              InstancePicking: resultObj.Invoicetype,
              BinCode: "",
              BinName: "",
              Status: resultObj.Status,
            })
          );
          navigate("/DispatchDetail");
        } else {
          fAlertToast("FAILED", "Wrong Barcode");
        }
      }
    }
  };
  const fLoad = async (e) => {
    dispatch(DispatchData_Set(sLoadObj));
    await GetSummaryList();
    LocationDispatchOnLoad.current?.focus();
  };

  const fOnRowClick = (e) => {
    dispatch(
      DispatchHead_Set({
        VocTyp: e.row.VocTyp,
        VocTypName: e.row.VocTypName,
        VocNo: e.row.VocNo,
        PostDate: e.row.PostDate,
        Party: e.row.Party,
        PartyName: e.row.PartyName,
        Loc: e.row.Loc,
        LocName: e.row.LocName,
        DocStatus: e.row.DocStatus,
        InstancePicking: e.row.Invoicetype,
        BinCode: "",
        BinName: "",
        Status: e.row.Status,
      })
    );
    navigate("/DispatchDetail");
  };
  //1st load
  const onLoadCall = async (e) => {
    setLoadObj((obj) => ({
      ...obj,
      loc: vRdxuserLoc[0]?.UID,
      statusVal: statusData[0]?.id,
      Scan: "",
    }));
    let summaryResp = await GetSummaryList();
    // PostDate: moment(obj.PostDate).format("DD/MM/YYYY")
    if (summaryResp?.length > 0) {
      // dispatch(DispatchList_Set({
      //   summaryResp
      // }))
    }
  };
  //API DISPATCHSUMMARY_GETROW
  const GetSummaryList = async () => {
    let vSummaryListObj = {
      loc: sLoadObj.loc,
      date1: moment(sLoadObj.dateFrom).format("MM/DD/YYYY"),
      date2: moment(sLoadObj.dateTo).format("MM/DD/YYYY"),
      status: sLoadObj.statusVal,
      scan: sLoadObj.Scan,
    };
    const vSummaryList = await fExecuteAPI(
      "DISPATCHSUMMARY_GETROW",
      vSummaryListObj
    );
    if (vSummaryList.Type == "SUCCESS") {
      let GridID = vSummaryList.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridrows(GridID);
      return GridID;
    } else if (vSummaryList.Type == "FAILED") {
      fAlertToast("FAILED", vSummaryList.Message);
      setGridrows([]);
      return [];
    } else if (
      vSummaryList.response.status == 500 ||
      vSummaryList.response.status == 400
    ) {
      fAlertToast("FAILED", vSummaryList.response.data.Status);
      setGridrows([]);
      return [];
    } else {
      fAlertToast("FAILED", "Error in loading summarylist");
      setGridrows([]);
      return [];
    }
  };
  useEffect(() => {
    onLoadCall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [sSummaryGridColumn2, setSummaryGridColumn2] = useState([]);

  useEffect(() => {
    GetGitterColumns(setSummaryGridColumn2, "WMSDISPATCH_SUMMARY", Gridcolumns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    LocationDispatchOnLoad.current?.focus();
  }, []);

   // modal start

   const [showModal, setShowModal] = useState(false);

  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs d-flex">
        <Dispatch_Breadcrumbs />
        <CmpButton
          xbtnName="Filter"
          xOnClick={() => {
            setShowModal(true);
          }}
          xVariant="contained"
          xSize="small"
        />
      </div>
      <div className="Instant-picking-head">
        {/* <Grid container spacing={2}>
          <Grid item lg={2} md={4} xs={6}>
            <CmpSelectBox
              xLabelText="Location"
              xValue={sLoadObj.loc === "" ? vRdxuserLoc[0]?.UID : sLoadObj.loc}
              xOnChange={(event) => fOnChangeSelect(event)}
              xName={"loc"}
              xData={sLocation}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"From"}
              xValue={sLoadObj.dateFrom}
              xOnChange={(newValue) => {
                setLoadObj((obj) => ({ ...obj, dateFrom: newValue.$d }));
              }}
              xName={"dateFrom"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"To"}
              xValue={sLoadObj.dateTo}
              xOnChange={(newValue) =>
                setLoadObj((obj) => ({ ...obj, dateTo: newValue.$d }))
              }
              xName={"dateTo"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6}>
            <CmpSelectBox
              xLabelText="Status"
              xValue={
                sLoadObj.statusVal == "" ? statusData[0].id : sLoadObj.statusVal
              }
              xOnChange={(event) => fOnChangeSelect(event)}
              xName={"statusVal"}
              xData={statusData}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={12}>
            <CmpTextFieldEnter
              xref={LocationDispatchOnLoad}
              xLabelText={"Scan"}
              xVariant={"outlined"}
              xValue={sLoadObj.scan}
              xOnChange={(event) => fOnChangeInput(event)}
              xReadOnly={false}
              xType={"text"}
              xName={"Scan"}
              xOnKeyUp={(e) => {
                fOnKeyUp(e);
              }}
              xOnEnter={(e) => {
                fOnKeyUp(sEnterKeyObj);
              }}
              xSmShow={!!vMediaQuery}
            />
          </Grid>
          <Grid
            item
            lg={2}
            md={4}
            xs={12}
            className="bintransfet-data-load-btn"
          >
            <CmpButton
              xbtnName="Load"
              xOnClick={fLoad}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
            />
          </Grid>
        </Grid> */}

        <DispatchModal
          xOpen={showModal}
          fCloseModal={() => {
            setShowModal(false);
          }}
          xTitle="Filter"
          component={
            <>
              <Grid container spacing={2}>
                <Grid item md={4} xs={6}>
                  <CmpSelectBox
                    xLabelText="Location"
                    xValue={
                      sLoadObj.loc === "" ? vRdxuserLoc[0]?.UID : sLoadObj.loc
                    }
                    xOnChange={(event) => fOnChangeSelect(event)}
                    xName={"loc"}
                    xData={sLocation}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={false}
                    xErrorMessage={false}
                    xDisable={false}
                  />
                </Grid>
                <Grid item md={4} xs={6} className="bintransfer-data-date">
                  <CmpDatePicker
                    xLabelText={"From"}
                    xValue={sLoadObj.dateFrom}
                    xOnChange={(newValue) => {
                      setLoadObj((obj) => ({ ...obj, dateFrom: newValue.$d }));
                    }}
                    xName={"dateFrom"}
                    xError={false}
                    xErrorMessage={false}
                  />
                </Grid>
                <Grid item md={4} xs={6} className="bintransfer-data-date">
                  <CmpDatePicker
                    xLabelText={"To"}
                    xValue={sLoadObj.dateTo}
                    xOnChange={(newValue) =>
                      setLoadObj((obj) => ({ ...obj, dateTo: newValue.$d }))
                    }
                    xName={"dateTo"}
                    xError={false}
                    xErrorMessage={false}
                  />
                </Grid>
                <Grid item md={4} xs={6}>
                  <CmpSelectBox
                    xLabelText="Status"
                    xValue={
                      sLoadObj.statusVal == ""
                        ? statusData[0].id
                        : sLoadObj.statusVal
                    }
                    xOnChange={(event) => fOnChangeSelect(event)}
                    xName={"statusVal"}
                    xData={statusData}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={false}
                    xErrorMessage={false}
                    xDisable={false}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <CmpTextFieldEnter
                    xref={LocationDispatchOnLoad}
                    xLabelText={"Scan"}
                    xVariant={"outlined"}
                    xValue={sLoadObj.scan}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={false}
                    xType={"text"}
                    xName={"Scan"}
                    xOnKeyUp={(e) => {
                      fOnKeyUp(e);
                    }}
                    xOnEnter={(e) => {
                      fOnKeyUp(sEnterKeyObj);
                    }}
                    xSmShow={!!vMediaQuery}
                  />
                </Grid>
                <Grid
                  item
                  lg={2}
                  md={4}
                  xs={12}
                  className="bintransfet-data-load-btn"
                >
                  <CmpButton
                    xbtnName="Load"
                    xOnClick={fLoad}
                    xVariant="contained"
                    xDisabled={false}
                    xSize="small"
                  />
                </Grid>
              </Grid>
            </>
          }
        />

        <Box
          sx={{ height: vMediaQuery ? "45vh" : "70vh", width: "100%" }}
          className="bin-transfer-data"
        >
          {/* <DataGrid
            rowHeight={30}
            headerHeight={40}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
            }}
            rows={sGridrows}
            columns={sSummaryGridColumn2}
            // pageSize={5}
            // rowsPerPageOptions={[5]}
            hideFooter={sGridrows.length < 100}
            onRowClick={fOnRowClick}
            components={{
              Toolbar: GridToolbar,
            }}
          /> */}

          <DispatchSummaryTblCard data={sGridrows} onClick={fOnRowClick} />
        </Box>
      </div>
    </div>
  );
}
